<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`${activeId ? '编辑' : '新增'}设备材料检测`"
    width="1440px"
    height="100vh"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm', 'areaTreeData')"
  >
    <el-form v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item prop="reportCode">
            <template #label>
              <div>
                <span>委托编号</span>
                <el-tooltip v-if="!activeId" effect="dark" :content="'当前已有报告的最大编号：' + maxCode" placement="bottom-end">
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </div>
            </template>
            <el-input v-model.trim="editForm.reportCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="委托单位" prop="client">
            <el-input v-model.trim="editForm.client" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工程名称" prop="projectName">
            <el-input v-model.trim="editForm.projectName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12"></el-col>
        <el-col :span="12">
          <el-form-item label="创建时间" prop="totTime">
            <el-date-picker
              v-model="editForm.totTime"
              type="datetime"
              placeholder="请选择"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="140px" label="开工（委托）日期" prop="wtDate">
            <el-date-picker
              v-model="editForm.wtDate"
              type="date"
              placeholder="请选择"
              value-format="yyyy.MM.dd"
              format="yyyy.MM.dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测类别" prop="testType">
            <el-radio-group v-model="editForm.testType">
              <el-radio v-for="item in testTypeOptions" :key="item.code" :label="item.code">{{ item.name }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="样品信息" required>
            <el-button type="primary" @click="handleImportSamples">导入</el-button>
          </el-form-item>
        </el-col>

        <el-radio-group v-model="sampleInfoType" style="margin-left: 40px; margin-bottom: 14px">
          <el-radio-button label="委托样品信息">委托协议书样品信息</el-radio-button>
          <el-radio-button label="检测样品信息"></el-radio-button>
        </el-radio-group>

        <div v-if="editForm.sampleInfoList && editForm.sampleInfoList.length > 0" style="width: calc(100% - 80px)">
          <table v-show="sampleInfoType === '委托样品信息'" class="word-table">
            <tr>
              <td width="25%">样品名称</td>
              <td width="60%" class="label">检测项目</td>
              <td width="15%" class="label">是否外委</td>
            </tr>

            <template v-for="(item, index) in entrustSampleData">
              <tr :key="index">
                <td width="25%" :rowspan="item.nodes.length + 1">{{ item.name }}</td>
              </tr>
              <tr v-for="sample in item.nodes" :key="sample.code">
                <td width="60%" class="align-Left">
                  <el-checkbox v-model="sample.checked">{{ sample.name }}</el-checkbox>
                </td>
                <td width="15%">
                  <el-radio-group v-model="sample.isWw" size="mini">
                    <el-radio-button label="是"></el-radio-button>
                    <el-radio-button label="否"></el-radio-button>
                    <el-radio-button label="">空</el-radio-button>
                  </el-radio-group>
                </td>
              </tr>
            </template>
          </table>

          <table v-show="sampleInfoType === '检测样品信息'" class="word-table">
            <tr>
              <td width="18%" class="label">样品名称</td>
              <td width="12%" class="label">试件名称</td>
              <td width="6%" class="label">规格型号</td>
              <td width="8%" class="label">数量</td>
              <td width="20%" class="label">生产厂家</td>
            </tr>
            <tr v-for="(item, index) in editForm.sampleInfoList" :key="index">
              <td>{{ item.sampleBelong }}</td>
              <td>{{ item.sampleName }}</td>
              <td>{{ item.model }}</td>
              <td>{{ item.cnt }}</td>
              <td>{{ item.manufacturer }}</td>
            </tr>
          </table>
          <table v-show="sampleInfoType === '检测样品信息'" class="word-table">
            <tr>
              <td width="20%">
                <span class="label table-required">检测项目</span>
              </td>
              <td width="80%" class="label"><span class="label table-required">依据的标准名称及编号(含年号)</span></td>
            </tr>
            <tr v-for="(item, index) in editForm.basisTotalList" :key="index">
              <td>
                <span>{{ item.itemName }}</span>
              </td>
              <td>{{ item.basisName }}</td>
            </tr>
          </table>
        </div>

        <el-col :span="24">
          <el-form-item label="地址" prop="testAddress">
            <el-checkbox-group v-model="editForm.testAddress">
              <el-checkbox v-for="item in addressOptions" :key="item.code" :label="item.name"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测员" prop="testedBy">
            <el-select v-model="editForm.testedBy" placeholder="请选择" filterable>
              <el-option v-for="item in experimenterOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="审核人" prop="auditedBy">
            <el-select v-model="editForm.auditedBy" placeholder="请选择" filterable>
              <el-option v-for="item in auditorOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="批准人" prop="approvedBy">
            <el-select v-model="editForm.approvedBy" placeholder="请选择" filterable>
              <el-option v-for="item in approverOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <div class="footer-form-item">
        <div class="label">工程类型</div>
        <el-select v-model="editForm.etmtType" placeholder="请选择" @change="onEtmtTypeChange">
          <el-option v-for="item in etmtTypeOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </div>

      <div>
        <el-button @click="$emit('update:visible', false)">关 闭</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
      </div>
    </div>

    <!-- 导入委托信息 todo templateUrl  -->
    <MeterialImport
      :visible.sync="importVisible"
      :downLoadUrl="templateUrl"
      :otherData="{ etmtType: editForm.etmtType, reportCode: activeId && editForm.reportCode ? editForm.reportCode : '' }"
      @setEditForm="setEditForm"
    />
  </drag-dialog>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import MeterialImport from './MeterialImport';

import sampleListXL from './SampleListXL';
import sampleListBD from './SampleListBD';

import { getDictsByCode, getAreaTree } from '@/api/system';
import { getTotEntrustment, editTotEntrustmentJson, getTotEntrustmentReport } from '@/api/entrust';
import { getRoleUserList } from '@/api/user';

export default {
  components: { MeterialImport },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      editForm: {
        id: null,
        reportCode: '',
        client: '', // 委托单位
        projectName: '', // 工程名称
        totTime: '',
        wtDate: '',
        payOrg: '', // 付款单位
        sfcn: '', // 送检人
        sfcp: '', // 联系电话
        sfca1: '', // 送检人地址部分1
        sfca2: '', // 送检人地址部分2
        sfca3: '', // 送检人地址部分3
        sfca: '', // 送检人地址部分4
        testType: '', // 检测类别
        isSbct: 1, // 是否接受分包至其他有资质的检测机构
        reportType: 2, // 出具报告类型
        sampleDealWay: 1, // 样品处理方式
        deliveryType: null, // 报告领取方式
        serviceType: null, // 服务类型
        note: '', // 特殊说明
        isIvDdeliver: null, // 是否邮寄
        ivDdeliveryAddress: '', // 邮寄地址
        noteInner: '', // 内部特殊说明
        etmtType: 'petmt_type_xl', // 工程类型
        scac: '',
        testAddress: [], // 地址
        sampleInfoList: [],
        td: '',
        wd: '',
        testedTime: '',
        testedTimeCn: '',
        testedBy: '',
        auditedBy: '',
        approvedBy: '',
        gbDate: '',
        signDate: '',
        sampleCnt: '',
        etmtSync: ''
      },
      maxCode: '',
      etmtTypeOptions: [],
      testTypeOptions: [],
      areaTreeData: [],
      experimenterOptions: [],
      addressOptions: [],
      auditorOptions: [],
      approverOptions: [],
      rules: {
        client: [{ required: true, message: '请输入', trigger: 'blur' }],
        projectName: [{ required: true, message: '请输入', trigger: 'blur' }],
        totTime: [{ required: true, message: '请选择', trigger: 'change' }],
        wtDate: [{ required: true, message: '请选择', trigger: 'change' }],
        payOrg: [{ required: true, message: '请输入', trigger: 'blur' }],
        sfcn: [{ required: true, message: '请输入', trigger: 'blur' }],
        sfcp: [{ required: true, message: '请输入', trigger: 'blur' }],
        testType: [{ required: true, message: '请选择', trigger: 'change' }],
        reportType: [{ required: true, message: '请选择', trigger: 'change' }],
        sampleDealWay: [{ required: true, message: '请选择', trigger: 'change' }],
        deliveryType: [{ required: true, message: '请选择', trigger: 'change' }],
        serviceType: [{ required: true, message: '请选择', trigger: 'change' }],
        isIvDdeliver: [{ required: true, message: '请选择', trigger: 'change' }],
        scac: [{ required: true, message: '请选择', trigger: 'change' }],
        testAddress: [{ required: true, message: '请选择', trigger: 'change' }],
        testedBy: [{ required: true, message: '请选择', trigger: 'change' }],
        auditedBy: [{ required: true, message: '请选择', trigger: 'change' }],
        approvedBy: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      importVisible: false,
      templateUrl: '/uploadPath/excelmodel/tot_import_xl.xlsx?t=' + new Date().getTime(),
      detailLoading: false,
      submitLoading: false,
      sampleInfoType: '委托样品信息',
      entrustSampleData: [],
      resetDoc: false // 用于编辑状态下导入数据后重置文件保存状态
    };
  },
  computed: {
    cityTreeData({ editForm, areaTreeData }) {
      const parent = areaTreeData.filter(item => item.text == editForm.sfca1)?.[0];
      return parent?.nodes || [];
    },
    districtTreeData({ editForm, cityTreeData }) {
      const parent = cityTreeData.filter(item => item.text == editForm.sfca2)?.[0];
      return parent?.nodes || [];
    }
  },
  watch: {
    async visible(val) {
      if (val) {
        await this.getDictsByCode('petmt_type', 'etmtTypeOptions');
        await this.getDictsByCode('address_entrust', 'addressOptions');
        await this.getDictsByCode('test_type', 'testTypeOptions');

        const env = process.env.VUE_APP_BASE_ENV;

        if (env == 'dev') {
          // 测试环境
          // 获取实验室人员列表
          this.experimenterOptions = await this.getRoleUserList('8a8084828f4c6e3a018f50dfdafe03fc');
          // 获取报告审核人
          this.auditorOptions = await this.getRoleUserList('2c942eb49445204c01944566c1c20081');
          // 获取报告批准人
          this.approverOptions = await this.getRoleUserList('2c942eb49445204c0194456745340082');
        } else {
          // 获取实验室人员列表
          this.experimenterOptions = await this.getRoleUserList('2c942eb49768bf2e019786b4d687032b');
          // 获取报告审核人
          this.auditorOptions = await this.getRoleUserList('2c942eb496ce0b630196e7ba2d060667');
          // 获取报告批准人
          this.approverOptions = await this.getRoleUserList('2c942eb4973fa01f019743157a910205');
        }

        if (this.activeId) {
          this.getDetailData();
        } else {
          this.editForm.totTime = moment().format('YYYY-MM-DD HH:mm:ss');
          this.getReportCodeMax();
        }

        if (this.areaTreeData.length == 0) {
          this.getAreaTree();
        }
      }
    },
    'editForm.isIvDdeliver'(newVal) {
      if (newVal === 1) {
        this.editForm.deliveryType = 1;
      } else {
        this.editForm.deliveryType = 0;
      }
    },

    'editForm.deliveryType'(newVal) {
      if (newVal === 1) {
        this.editForm.isIvDdeliver = 1;
      } else {
        this.editForm.isIvDdeliver = 0;
      }
    }
  },
  methods: {
    async getReportCodeMax() {
      const { data } = await getTotEntrustmentReport();
      this.editForm.reportCode = data?.reportCodeStart ?? '';
      this.maxCode = data?.maxCode ?? '';
    },
    async getDetailData() {
      this.detailLoading = true;
      // todo 其它委托类型
      try {
        const { data } = await getTotEntrustment({ id: this.activeId });
        this.editForm = { ...this.editForm, ...data };

        // 回显委托协议书样品信息
        if (data.sampleOption) {
          let entrustSampleData = [];
          if (this.editForm.etmtType == 'petmt_type_xl' || this.editForm.etmtType == 'petmt_type_x') {
            entrustSampleData = cloneDeep(sampleListXL);
          } else {
            entrustSampleData = cloneDeep(sampleListBD);
          }

          const sampleOption = JSON.parse(data.sampleOption);
          entrustSampleData.forEach(item => {
            item.nodes.forEach(node => {
              const sample = sampleOption.find(sample => node.code == sample.code);
              node.checked = sample?.checked ?? false;
              node.isWw = sample?.isWw ?? '';
            });
          });
          this.entrustSampleData = entrustSampleData;
        } else {
          if (this.editForm.etmtType == 'petmt_type_xl' || this.editForm.etmtType == 'petmt_type_x') {
            this.entrustSampleData = cloneDeep(sampleListXL);
          } else {
            this.entrustSampleData = cloneDeep(sampleListBD);
          }
        }

        this.templateUrl =
          this.etmtTypeOptions.filter(item => item.code == this.editForm.etmtType)[0].value + '?t=' + new Date().getTime();

        this.editForm.testAddress = data.testAddress.split(',');

        this.$nextTick(() => {
          this.$refs.editForm.clearValidate();
        });
      } finally {
        this.detailLoading = false;
      }
    },
    // 导入
    handleImportSamples() {
      this.importVisible = true;
    },
    changeProvince() {
      this.editForm.sfca2 = '';
      this.editForm.sfca3 = '';
    },
    changeCity() {
      this.editForm.sfca3 = '';
    },
    //  todo 限制 填充导入的信息
    setEditForm(data) {
      this.editForm = { ...this.editForm, ...data };

      const sampleInfoList = data.sampleInfoList || [];
      let entrustSampleData = [];

      if (this.editForm.etmtType == 'petmt_type_xl' || this.editForm.etmtType == 'petmt_type_x') {
        entrustSampleData = cloneDeep(sampleListXL);
        entrustSampleData.forEach(item => {
          item.nodes.forEach(node => {
            if (node.sampleId) {
              const checked = sampleInfoList.some(sample => {
                return node.sampleId == sample.sampleId && node.modelCode == sample.modelCode;
              });
              if (checked) {
                node.checked = true;
                node.isWw = '否';
              }
            }
          });
        });
      } else {
        entrustSampleData = cloneDeep(sampleListBD);
        entrustSampleData.forEach(item => {
          item.nodes.forEach(node => {
            if (node.sampleId) {
              const checked = sampleInfoList.some(sample => {
                return node.sampleId.includes(sample.sampleId) && node.modelCode.includes(sample.modelCode);
              });
              if (checked) {
                node.checked = true;
                node.isWw = '否';
              }
            }
          });
        });
      }
      console.log('entrustSampleData 打印:', entrustSampleData);
      this.entrustSampleData = entrustSampleData;
      if (this.activeId) this.resetDoc = true;

      this.$nextTick(() => {
        this.$refs.editForm.clearValidate();
      });
    },
    onEtmtTypeChange(val) {
      this.templateUrl = this.etmtTypeOptions.filter(item => item.code == val)[0].value + '?t=' + new Date().getTime();

      this.editForm = {
        ...this.editForm,
        sampleInfoList: []
      };
      this.$nextTick(() => {
        this.$refs.editForm.clearValidate();
      });
    },
    handleSubmit() {
      const { isIvDdeliver, ivDdeliveryAddress, sampleInfoList, testAddress } = this.editForm;
      if (!this.editForm.sampleInfoList || this.editForm.sampleInfoList.length == 0)
        return this.$message.warning('请导入样品信息！');
      if (isIvDdeliver == 1 && !ivDdeliveryAddress) return this.$message.warning('请输入邮寄地址！');

      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          // 处理样品信息
          const sampleInfoListValue = sampleInfoList.map((item, index) => {
            return {
              ...item,
              eng: 1
            };
          });

          // 处理委托协议书样品信息
          let sampleOption = [];
          this.entrustSampleData.forEach(item => {
            item.nodes.forEach(node => {
              sampleOption.push({
                code: node.code,
                checked: node.checked,
                isWw: node.isWw
              });
            });
          });

          const testAddressValue = testAddress.join(',');

          const params = {
            ...this.editForm,
            testAddress: testAddressValue,
            sampleOption: JSON.stringify(sampleOption),
            resetDoc: this.resetDoc ? 1 : 0
          };

          try {
            await editTotEntrustmentJson(params);
            this.$message.success('提交成功!');
            this.$emit('update:visible', false);
            this.$emit('refresh');
          } finally {
            this.submitLoading = false;
          }
        } else {
          this.$message.warning('请完善必填项!');
        }
      });
    },
    // 获取字典
    async getDictsByCode(code, dataType) {
      const { data } = await getDictsByCode({ code });
      this[dataType] = data;
    },
    // 省市区树形
    async getAreaTree() {
      const { data } = await getAreaTree();
      this.areaTreeData = data || [];
    },
    // 根据角色ID获取用户列表
    async getRoleUserList(roleId) {
      const { data } = await getRoleUserList({ pageNum: 1, pageSize: 9999, select: 1, roleId });
      return data.list || [];
    }
  },

  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.el-button--mini.is-circle {
  padding: 5px;
}

.word-table {
  margin-right: 40px;
  margin-left: 40px;
}

.break-radio {
  .el-radio {
    margin-bottom: 10px;
  }
  .radio-line {
    display: flex;
    align-items: center;
    .el-radio {
      margin-bottom: 0;
    }
  }
}
</style>
